export default "__VITE_ASSET__DjZlRaER__"